import { Card, CardHeader, CardTitle } from '@/components'

import { Cliente } from '../entities/cliente'
import { ItemField } from './utils/item-field'

export function ClienteDetailsCard({ cliente }: { cliente: Cliente }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Dados do cliente</CardTitle>
      </CardHeader>

      <div className="space-y-4">
        <ItemField label="Nome">
          <div>
            {cliente.nomeFantasia && (
              <p className="font-bold">{cliente.nomeFantasia}</p>
            )}
            <p>{cliente.razaoSocial}</p>
          </div>
        </ItemField>
        <ItemField label="Contato">
          {cliente.contatoNome ?? 'Não informado'}
        </ItemField>
        <ItemField label="Localidade">
          {cliente.localidade ?? 'Não informado'}
        </ItemField>
        <ItemField label="E-mail">
          {cliente.contatoEmail ?? 'Não informado'}
        </ItemField>
      </div>
    </Card>
  )
}
